/**
 * Rounds a number to a fixed number of decimal places.
 * Used to avoid floating-point precision issues (e.g. 0.03 - 0.01 = 0.01999999999999999).
 */
export const roundDecimal = (n, decimals = 6) => {
  if (!Number.isFinite(n)) return n;
  const factor = Math.pow(10, decimals);
  return Math.round(n * factor) / factor;
};
